/* eslint-disable react-hooks/exhaustive-deps */
import { Input } from "reactstrap";
import { SearchCrocs } from "../../../../utils/Constant";
import { ChangeEvent, useEffect, useState } from "react";
import { MenuItem, SearchSuggestionItem, SubMenuType } from "../../../../types/layout/SidebarType";
import { LI, SVG } from "../../../../AbstractElements";
import SearchSuggestionList from "./SearchSuggestionList";
import { setResponsiveSearch } from "../../../../redux-tool-kit/reducers/LayoutSlice";
import { useAppDispatch } from "../../../../redux-tool-kit/Hooks";
import { useMenuList } from "../../../../data/layout-data/useMenuList";
import { getLinkItemsArray } from "../../../../redux-tool-kit/reducers/BookmarkHeaderSlice";

const ResponsiveSearchInput = () => {
  const [arr, setArr] = useState<SearchSuggestionItem[]>([]);
  const [searchedWord, setSearchedWord] = useState<string>("");
  const [open, setOpen] = useState(false);
  const [searchedArray, setSearchedArray] = useState<SearchSuggestionItem[]>([]);
  const dispatch = useAppDispatch();
  const menuList = useMenuList();

  useEffect(() => {
    const suggestionArray: SearchSuggestionItem[] = [];
    let num = 0;
    const getAllLink = (item: SubMenuType, icon: string | undefined) => {
      if (item.children) {
        item.children.forEach((ele: SubMenuType) => {
          getAllLink(ele, icon);
        });
      } else {
        num = num + 1;
        suggestionArray.push({
          icon,
          title: item.title,
          path: item.path ? item.path : "",
          bookmarked: false,
          id: num,
        });
      }
    };
    menuList.forEach((item: MenuItem) => {
      item.Items?.forEach((child: SubMenuType) => {
        getAllLink(child, child.icon);
      });
    });
    setArr(suggestionArray);
    dispatch(getLinkItemsArray(suggestionArray));
  }, [menuList]);

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchedWord(e.target.value);
    const result = arr.filter((item) =>
      item.title?.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setSearchedArray(result);
  };

  return (
    <>
      <LI onClick={() => dispatch(setResponsiveSearch())} className="serchinput">
        <div className="searchbox" onClick={() => setOpen(!open)}>
          <SVG iconId="fill-search" />
        </div>
        <div className={`form-group search-form ${open ? "open" : ""}`}>
          <Input
            type="text"
            placeholder={SearchCrocs}
            name="q"
            onChange={handleSearch}
            value={searchedWord}
          />
          <div
            className={`Typeahead-menu w-100 custom-scrollbar ${
              searchedWord.length ? "is-open" : ""
            }`}
          >
            <SearchSuggestionList
              searchedArray={searchedArray}
              setSearchedWord={setSearchedWord}
            />
          </div>
        </div>
      </LI>
    </>
  );
};

export default ResponsiveSearchInput;